import _ from 'lodash'
var blocks = [{
  'text': 'Giornali',
  'icon': '🗞',
  'selected': false
}, {
  'text': 'Libri',
  'icon': '📚',
  'selected': false
}, {
  'text': 'Fotografie',
  'icon': '📷',
  'selected': false
}, {
  'text': 'Video',
  'icon': '📽',
  'selected': false
}, {
  'text': 'Lettere',
  'icon': '💌',
  'selected': false
}, {
  'text': 'Oggetti',
  'icon': '🎈',
  'selected': false
}, {
  'text': 'Documenti',
  'icon': '🗃',
  'selected': false
}, {
  'text': 'Audio',
  'icon': '🎻',
  'selected': false
}, {
  'text': 'Pubblicità',
  'icon': '📣',
  'selected': false
}, {
  'text': 'Arte',
  'icon': '🎨 ',
  'selected': false
}, {
  'text': 'Mappe',
  'icon': '🗺',
  'selected': false
}, {
  'text': 'Segreti',
  'icon': '🗝',
  'selected': false
}]

function delayPromise (delay = 300) {
  return new Promise((resolve, reject) => {
    _.delay(resolve, delay)
  })
}

export default {
  props: ['ok', 'ko', 'popup'],
  data () {
    return {
      items: []
    }
  },
  created () {
    this.ko.text = this.ok.text
    _.reduce(_.chunk(blocks, 4), async (promise, item) => {
      await promise      
      this.items = this.items.concat(item)
      return delayPromise()
    }, delayPromise())
    this.$emit('itemsLoaded')
  },
  methods: {
    select () {
      this.$emit('select', _.every(this.items, { selected: true }) ? this.ok : this.ko)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/question/table/table.js